import { JSX } from "react";

export const BottomNavigation = ({ menus }: { menus: JSX.Element[] }) => {
  return (
    <nav className="mobile-column fixed inset-x-0 bottom-0 z-10 bg-white dark:bg-zinc-950">
      <div className="flex">{menus}</div>
    </nav>
  );
};
